/* DJI MXG · Servicio: scoped popup controller for the eight service cards. */
(function () {
  'use strict';

  if (window.DJIMXServicePopups) {
    window.DJIMXServicePopups.initAll(document);
    return;
  }

  var active = null;

  function getFocusable(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hasAttribute('hidden') && element.getClientRects().length > 0;
    });
  }

  function createOverlay(root) {
    var overlay = root.__djimxServiceOverlay;
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'pf-popup-overlay djimx-service-popup-overlay';
    overlay.setAttribute('data-djimx-service-overlay', '');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', function () {
      close(true);
    });
    document.body.appendChild(overlay);
    root.__djimxServiceOverlay = overlay;
    return overlay;
  }

  function close(restoreFocus) {
    if (!active) return;

    var state = active;
    active = null;

    state.dialog.removeAttribute('data-pf-popup-open');
    state.dialog.setAttribute('aria-hidden', 'true');
    state.trigger.setAttribute('aria-expanded', 'false');
    state.overlay.removeAttribute('data-open');
    document.body.classList.remove('djimx-service-popup-open');

    if (restoreFocus && state.trigger.isConnected) {
      state.trigger.focus();
    }
  }

  function openDialog(root, trigger, dialog) {
    if (!dialog) return;

    if (active) close(false);

    var overlay = createOverlay(root);
    active = { root: root, trigger: trigger, dialog: dialog, overlay: overlay };
    overlay.setAttribute('data-open', '');
    dialog.setAttribute('data-pf-popup-open', '');
    dialog.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('djimx-service-popup-open');

    window.requestAnimationFrame(function () {
      if (!active || active.dialog !== dialog) return;
      var closeButton = dialog.querySelector('[data-djimx-service-close], .pf-popup-close');
      (closeButton || dialog).focus();
    });
  }

  function open(root, trigger) {
    var dialogId = trigger.getAttribute('aria-controls');
    var dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!dialog || !root.contains(dialog)) return;
    openDialog(root, trigger, dialog);
  }

  function handleKeydown(event) {
    if (!active) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(active.dialog);
    if (!focusable.length) {
      event.preventDefault();
      active.dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.djimxServicePopupReady === 'true') return;

    root.dataset.djimxServicePopupReady = 'true';
    Array.prototype.forEach.call(root.querySelectorAll('[data-djimx-service-trigger]'), function (trigger) {
      trigger.addEventListener('click', function () {
        open(root, trigger);
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(root, trigger);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-djimx-service-close]'), function (button) {
      button.addEventListener('click', function () {
        close(true);
      });
    });
  }

  function destroyRoot(root) {
    if (!root) return;
    if (active && active.root === root) close(false);
    if (root.__djimxServiceOverlay) {
      root.__djimxServiceOverlay.remove();
      delete root.__djimxServiceOverlay;
    }
    delete root.dataset.djimxServicePopupReady;
  }

  /* Adaptador para popups nativos de PageFly (data-action="popup-element"): el runtime de PageFly
     está adelgazado y no los abría, por eso en MÓVIL «Servicio y Soporte» no mostraba nada. En cada
     pf-root NO gestionado por el sistema propio (sin [data-djimx-service-trigger]) emparejamos por
     ORDEN cada disparador con su .pf-popup-dialog (convención de PageFly) y reutilizamos el mismo
     open/overlay/close. No toca el escritorio (que sí usa el sistema propio con aria-controls). */
  function initPageflyPopups(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('.pf-root')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('.pf-root')));
    }
    roots.forEach(function (root) {
      if (root.dataset.djimxPfPopupReady === 'true') return;
      if (root.querySelector('[data-djimx-service-trigger]')) return; /* ya lo gestiona el sistema propio */
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-action="popup-element"]'));
      var dialogs = Array.prototype.slice.call(root.querySelectorAll('.pf-popup-dialog'));
      if (!triggers.length || triggers.length !== dialogs.length) return;
      root.dataset.djimxPfPopupReady = 'true';

      /* El orden DOM de disparadores y diálogos NO coincide (emparejar por índice abría el diálogo
         equivocado). Emparejamos por CONTENIDO: puntuamos cada par por el nº de palabras iniciales que
         comparten la etiqueta del disparador y el cuerpo del diálogo (que empieza por su título), y
         asignamos de mayor a menor puntuación (voraz, cada diálogo una vez). Los que no comparten
         ninguna palabra (p.ej. "Asesoría de expertos DJI" ↔ "Un experto de DJI…") se asignan por
         descarte con los diálogos que queden. */
      var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
      var words = function (s) { return norm(s).split(' ').filter(Boolean); };
      var dialogKey = function (d) { var b = d.querySelector('.pf-popup-body') || d; return norm(b.textContent); };
      var sharedLead = function (a, b) { var i = 0; while (i < a.length && i < b.length && a[i] === b[i]) i++; return i; };
      var trigWords = triggers.map(function (t) { return words(t.textContent); });
      var dlgWords = dialogs.map(function (d) { return words(dialogKey(d)); });
      var scored = [];
      for (var ti = 0; ti < triggers.length; ti++) {
        for (var di = 0; di < dialogs.length; di++) {
          scored.push({ ti: ti, di: di, s: sharedLead(trigWords[ti], dlgWords[di]) });
        }
      }
      scored.sort(function (a, b) { return b.s - a.s; });
      var pairing = new Array(triggers.length);
      var dialogUsed = {};
      scored.forEach(function (p) {
        if (p.s > 0 && pairing[p.ti] === undefined && !dialogUsed[p.di]) {
          pairing[p.ti] = dialogs[p.di];
          dialogUsed[p.di] = true;
        }
      });
      var leftover = dialogs.filter(function (d, i) { return !dialogUsed[i]; });
      for (var pi = 0; pi < triggers.length; pi++) {
        if (pairing[pi] === undefined) pairing[pi] = leftover.shift();
      }

      triggers.forEach(function (trigger, index) {
        var dialog = pairing[index];
        trigger.style.cursor = 'pointer';
        if (!trigger.getAttribute('role')) trigger.setAttribute('role', 'button');
        if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function (event) { event.preventDefault(); openDialog(root, trigger, dialog); });
        trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openDialog(root, trigger, dialog);
        });
      });
      dialogs.forEach(function (dialog) {
        var closeButton = dialog.querySelector('.pf-popup-close, [data-djimx-service-close]');
        if (closeButton) closeButton.addEventListener('click', function () { close(true); });
      });
    });
  }

  function initAll(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-djimx-service], [data-djimx-service-mobile]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-djimx-service], [data-djimx-service-mobile]')));
    }
    roots.forEach(initRoot);
    initPageflyPopups(scope || document);
  }

  document.addEventListener('keydown', handleKeydown);
  /* Cierre robusto delegado: cualquier clic en un botón de cierre (.pf-popup-close) cierra el popup
     activo, independientemente de cuándo se creó el diálogo. */
  document.addEventListener('click', function (event) {
    if (!active) return;
    var target = event.target;
    if (target && target.closest && target.closest('.pf-popup-close, [data-djimx-service-close]')) {
      event.preventDefault();
      close(true);
    }
  }, true);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    if (event.target.matches && event.target.matches('[data-djimx-service], [data-djimx-service-mobile]')) {
      destroyRoot(event.target);
    }
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-djimx-service], [data-djimx-service-mobile]'), destroyRoot);
  });

  window.DJIMXServicePopups = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
